import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import apiService from '../../../utlis/apiService';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button, Modal } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
  maxHeight: '80%',
};

const BatchLog = ({ id }) => {
  const [activityLogs, setActivityLogs] = useState([]);
  const [activityModal, setActivityModal] = useState(false);
  const [activityData, setActivityData] = useState('');

  const fetchActivityLogs = async () => {
    try {
      const response = await apiService.get(`/batch/getActivityLogsByBatchId?batchId=${id}`);
      
      setActivityLogs(response?.data?.activityLogs);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchActivityLogs();
  }, [id]);

  const formatDate = (myDate) => {
    const date = new Date(myDate);

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };

    const formattedDate = date.toLocaleString('en-US', options);

    return formattedDate;
  };

  const getTriggerRow = (row) => {
    const data = row?.changes;
    
    if(data) {
      setActivityModal(true);
      setActivityData(data);
    }
    else {
      setActivityData('');
      setActivityModal(true);
    }
  }

  const RenderData = ({ data }) => {
    if (Array.isArray(data)) {
        return (
            <ul>
                {data.map((item, index) => (
                    <li key={index}>
                        <RenderData data={item} />
                    </li>
                ))}
            </ul>
        );
    } else if (typeof data === "object" && data !== null) {
        return (
            <div style={{ marginLeft: "20px" }}>
                {Object.entries(data).map(([key, value]) => (
                    <div key={key}>
                        <strong>{key}:</strong> <RenderData data={value} />
                    </div>
                ))}
            </div>
        );
    } else {
        return <span>{data}</span>;
    }
  };
  
  return (
    <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
      <Typography variant="h6" gutterBottom>
        Activity Logs
      </Typography>
      <List>
        {activityLogs.map((item, index) => (
          <React.Fragment key={item._id}>
            <div style={{ marginTop: '10px' }} onClick={() => getTriggerRow(item)}>
              <div style={{ fontSize: '14px', fontWeight: 600 }}>{formatDate(item.timestamp)}</div>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>User</TableCell>
                      <TableCell>User Email</TableCell>
                      <TableCell>Action</TableCell>
                      <TableCell>Message</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{item?.performedBy	}</TableCell>
                      <TableCell>{item?.performedByEmail	}</TableCell>
                      <TableCell>{item?.action}</TableCell>
                      <TableCell>{item?.message}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {index < activityLogs.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Modal
          open={activityModal}
          onClose={() => setActivityModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Box sx={style}>
              <div>
                  {activityData.length ? 
                    Object.entries(activityData).map(([key, value]) => (
                      <div key={key}>
                          <strong>{key}:</strong> <RenderData data={value} />
                      </div>
                    ))
                  : 'No Changes'}
                  <div style={{ textAlign: 'center' }}>
                      <Button variant="outlined" sx={{ marginRight: '10px' }} onClick={() => setActivityModal(false)}>Close</Button>
                  </div>
              </div>
          </Box>
      </Modal>

    </Paper>
  );
};

export default BatchLog;
